import { render, staticRenderFns } from "./AppointmentIndex.vue?vue&type=template&id=7ddeb8b0"
import script from "./AppointmentIndex.vue?vue&type=script&lang=js"
export * from "./AppointmentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports